import { ReactNode } from "react";
import styles from "./styles.module.scss";
import { BaseProps } from "../../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../../utilities/getHtmlPropsFromBaseProps";
import { useValidity } from "../../ValidityGroup";
import { Body } from "capitalrx-components-2.0/lib/typography";

/**
 * The `CharacterCount` component properties.
 */
export interface CharacterCountProps extends BaseProps {

  /**
  * A ReactNode passed to be wrapped by CharacterCount.
  */
  readonly children?: ReactNode

  /**
  * Count of characters typed.
  */
  readonly characterCount: number;

  /**
  * Maximum length of characters.
  */
  readonly maxLength?: number;
}

/**
 * An input component character count block.
 */
export const CharacterCount = (props: CharacterCountProps ) => {
  const { characterCount, maxLength, children } = props;
  const [invalid] = useValidity();

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.CharacterCount, "character-count", { invalid }],
    testIdPrefix: "character-count",
  });

  if (!maxLength) return children;

  const characterLengthMessage = `${characterCount}/${maxLength} characters`;

  return (
    <Body {...getBasePropsFromHtmlProps(baseHtmlProps)} inline size="mini" >
      {characterLengthMessage}
      {children
        && (<>. {children}&nbsp;</>)
      }
    </Body>
  );
};
